import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import AOS from 'aos';
import 'aos/dist/aos.css';
import AboutIntro from '../components/AboutIntro';
import AboutMissionVision from '../components/AboutMissionVision';
import AboutFacilities from '../components/AboutFacilities';
import RecognitionCertificates from '../components/RecognitionCertificates';


const About = ({ language }) => {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <SEO
        title="About Us"
        description="Learn about Blue Nest Hotel's mission, vision, and exceptional facilities in Addis Ababa."
        url="/about"
      />
      <AboutIntro language={language} />
      <AboutMissionVision language={language} />
      <RecognitionCertificates language={language} />
      <AboutFacilities language={language} />

    </>
  );
};

export default About;
